export default __webpack_public_path__ + "static/media/mlbFantasyPWRSBannerTitle.2810d68c.png";